import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from '../../../../components/Sessions/Table';
import { useLazyGetPastSessionsQuery } from '../../../../../store/services/student/SessionService';
import { Dropdown } from 'react-bootstrap';
import { getColumns } from '../../../../components/Dashboard/Columns';
import Pagination from '../../../../components/Dashboard/Pagination';

export const StudentSessionsHistory = ({showStudentName = false, showLanguage = true}) => {
  const navigate = useNavigate();
  const [sessionsData, setSessionsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('');
  const [pageSize] = useState(10);

  const [triggerGetPastSessions, { data, isLoading, error }] = useLazyGetPastSessionsQuery();
  console.log(data);

  const fetchData = () => {
    triggerGetPastSessions({ pageNumber: currentPage, pageSize, search: searchTerm, filter });
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchTerm, filter]);

  useEffect(() => {
    if (data?.data) {
      setSessionsData(data.data.items || []);
      setTotalCount(data.data.totalCount || 0);
    }
  }, [data]);

  const handleFilterChange = (value) => {
    setFilter(value === 'All' ? '' : value);
    setCurrentPage(1);
  };

  if (isLoading) return <div className="text-center py-5"><div className="spinner-border" role="status"></div></div>;
  if (error) return <div className="alert alert-danger">Error loading session history.</div>;

  return (
    <div className="bg-white">
      <div className="page-title flex-wrap mb-3">
        <div className="input-group search-area mb-md-0 ml-3">
          <input
            type="text"
            className="form-control ps-4"
            placeholder="Search session history..."
            value={searchTerm}
            onChange={(e) => {
              setCurrentPage(1);
              setSearchTerm(e.target.value);
            }}
          />
        </div>
        
        <div className="ms-3">
          <Dropdown>
            <Dropdown.Toggle variant="outline-primary">
              {filter || 'Select Status'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleFilterChange('All')}>
                All
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleFilterChange('Completed')}>
                Completed
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleFilterChange('Cancelled')}>
                Cancelled
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleFilterChange('Missed')}>
                Missed
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <Table
        data={sessionsData}
        columns={getColumns(sessionsData, showStudentName, showLanguage, true)}
        pageSize={pageSize}
        filterConfig={[]}
        buttonConfig={[]}
        searchableColumns={[]}
        onRowClick={(item) => navigate(`/sessions/sessionDetails/${item.sessionId}`, { state: { fromHistory: true } })}
      />

      <Pagination currentPage={currentPage} totalCount={totalCount}
            pageSize={pageSize} onPageChange={setCurrentPage} />
    </div>
  );
};